import * as adminActionTypes from "./actionTypes";

export function fetchUserInfo(payload) {
    return {
        type: adminActionTypes.FETCH_USER_INFO,
        ...payload,
    };
}
export function fetchUserInfoSuccess(data) {
    return {
        type: adminActionTypes.FETCH_USER_INFO_SUCCESS,
        ...data,
    };
}

export function fetchSearchRecords(searchParam) {
    return {
        type: adminActionTypes.FETCH_SEARCH_RECORDS,
        payload: searchParam,
    };
}
export function fetchSearchRecordsSuccess(data) {
    return {
        type: adminActionTypes.FETCH_SEARCH_RECORDS_SUCCESS,
        ...data,
    };
}
export function resetFetchSearchRecords() {
    return {
        type: adminActionTypes.FETCH_SEARCH_RECORDS_RESET
    }
}
export function fetchContractorStatus(contractorObj) {
    return {
        type: adminActionTypes.FETCH_CONTRACTOR_INFO,
        payload: contractorObj,
    };
}
export function fetchContractorStatusSuccess(data) {
    return {
        type: adminActionTypes.FETCH_CONTRACTOR_INFO_SUCCESS,
        ...data,
    };
}
export function updateContractorSelection(contractorObj) {
    return {
        type: adminActionTypes.UPDATE_CONTRACTOR_SELECTION,
        payload: contractorObj,
    };
}
export function updateReceivedDate(receivedDate) {
    return {
        type: adminActionTypes.UPDATE_RECEIVED_DATE,
        payload: receivedDate,
    };
}
export function updateWaiverReceived(waiverReceived) {
    return {
        type: adminActionTypes.UPDATE_WAIVER_RECEIVED,
        payload: waiverReceived,
    };
}
export function fetchWarrantyDetails(warrantyID) {
    return {
        type: adminActionTypes.FETCH_WARRANTY_DETAILS,
        payload: warrantyID,
    };
}
export function fetchWarrantyDetailsSuccess(warrantyDetails) {
    return {
        type: adminActionTypes.FETCH_WARRANTY_DETAILS_SUCCESS,
        payload: warrantyDetails,
    };
}
export const updateFormSubmittedStatus = (status) => {
    return {
        type: adminActionTypes.UPDATE_FORM_SUBMITTED_STATUS,
        isSubmitted: status,
    };
};

export const deleteSubmittedWarrantyClick = (warrantyId) => {
    return {
        type: adminActionTypes.DELETE_SUBMITTED_WARRANTY,
        payload: warrantyId,
    };
};

export const deleteShoppingCartClick = (shoppingCartId) => {
    return {
        type: adminActionTypes.DELETE_SUBMITTED_SHOPPING_CART,
        payload: shoppingCartId,
    };
};

export const invalidWarrentyIdEntry = (response) => {
    return {
        type: adminActionTypes.INVALID_WARRANTY_ENTRY,
        payload: response.data,
    };
};
